import { Label, RadioGroup, RadioGroupItem } from "@design-system/shadcn";
import React, { useCallback } from "react";

import { useFieldContext } from "../core/form-contexts";

export type Option = { value: string; label: string };

interface FormFieldRadioGroupProps extends Omit<
  React.ComponentProps<typeof RadioGroup>,
  "name" | "value" | "onValueChange"
> {
  options: Option[];
}

function FormFieldRadioGroup({ options, ...props }: FormFieldRadioGroupProps) {
  const field = useFieldContext<string>();

  if (!field) {
    throw new Error("FormFieldRadioGroup must be used within form.AppField");
  }

  const changeHandler = useCallback(
    (value: string) => field.handleChange(value),
    [field]
  );

  return (
    <RadioGroup
      name={field.name}
      value={field.state.value}
      onValueChange={changeHandler}
      {...props}
    >
      {options.map((option) => (
        <div className="flex items-center gap-2" key={option.value}>
          <RadioGroupItem value={option.value} id={option.value} />
          <Label htmlFor={option.value}>{option.label}</Label>
        </div>
      ))}
    </RadioGroup>
  );
}

export { FormFieldRadioGroup };
export type { FormFieldRadioGroupProps };
